import React from 'react';
import CategoryBadges from './CategoryBadges';
import './css/PlayerIdentity.css';

const PlayerIdentity = ({ player, icon }) => {
  const yahooId = player.yahoo_id != null && player.yahoo_id !== ''
    ? String(player.yahoo_id)
    : '';
  const nhlId = player.nhl_id != null && player.nhl_id !== ''
    ? String(player.nhl_id)
    : '';
  // Prefer Yahoo profile when available; fall back to NHL.com for nhl_id-keyed players.
  const profileHref = yahooId
    ? `https://sports.yahoo.com/nhl/players/${yahooId}`
    : nhlId
      ? `https://www.nhl.com/player/${nhlId}`
      : null;
  const name = player.name || player.player_name;
  const team = player.team_abr || player.nhl_team;
  const positions = Array.isArray(player.pos) ? player.pos.join(', ') : player.pos;

  return (
    <div className="player-identity">
      {player.headshot_url && (
        <img
          src={player.headshot_url}
          alt={name}
          className="player-identity-image"
        />
      )}
      <div>
        <div className="player-identity-name">
          {profileHref ? (
            <a href={profileHref}>{name}</a>
          ) : (
            name
          )}
          {icon && (
            <span className="player-identity-icon">
              <img src={icon} alt="" />
            </span>
          )}
        </div>
        <div className="player-identity-details">
          <strong>{team} - {positions}</strong>
          <CategoryBadges player={player} />
        </div>
      </div>
    </div>
  );
};

export default PlayerIdentity;
